import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Multiple from 'Components/Multiple'
import Search from 'Components/Search'
import Select from 'Components/Select'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents/index'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'



class DatagridContact extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return <Search unsave={this.props.unsave} raz={true} defaultSearch={this.props.defaultSearch} path={'crm'}
      requete={'client'}
      search={this.props.search || 'client_' + (this.props.name || '') + User.Entite.get().id}>
      <SearchClient searchProps={this.props.searchProps} />
    </Search>
  }

}

class SearchClient extends React.Component {

  constructor(props) {
    super(props)
    console.log('Search fournisseur', props)


    const requestSearch = EurestoClone(props.search)
    if (requestSearch['grc_information_tiers_donnees.information_tiers_id']) {
      requestSearch.acronis = props.search['grc_information_tiers_donnees.libelle']
    }
    delete requestSearch['grc_information_tiers_donnees.information_tiers_id']
    delete requestSearch['grc_information_tiers_donnees.libelle']


    this.state = {
      disabled: props.searchProps && props.searchProps.disabled || {},
      search: requestSearch,
      key: Utils.getRandomNumber(),
    }
  }

  searchClient = async (data, name) => {
    const search = this.state.search
    search[name] = data


    const requestSearch = EurestoClone(search)

    if (requestSearch.acronis) {
      delete requestSearch.acronis
      requestSearch['grc_information_tiers_donnees.information_tiers_id'] = 123
      requestSearch['grc_information_tiers_donnees.libelle'] = search.acronis
    } else {
      delete requestSearch['grc_information_tiers_donnees.information_tiers_id']
      delete requestSearch['grc_information_tiers_donnees.libelle']
    }

    this.setState({
      search: search,
    }, () => this.props.searching && this.props.searching(requestSearch))
  }

  render() {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5, overflow: 'visible' }}
        justify={'flex-start'}
        alignItems={'stretch'}
        alignContent={'flex-start'}
        direction={'column'}>
        <DataComponent
          title={EurestoI18n.t('crm:Qualité')}
          name="qualite_id"
          disabled={this.state.disabled.qualite_id}
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.searchClient}
          data={this.state.search.qualite_id}
          object={Constants.donnee.qualite}
          module={Constants.module.CRM}
        />
        <Input
          autoFocus={true}
          onChange={this.searchClient}
          disabled={this.state.disabled.nom}
          name="nom"
          type="text"
          className="upText"
          value={this.state.search.nom}
          title={EurestoI18n.t('crm:Nom')}
        />
        <Input
          onChange={this.searchClient}
          name="prenom"
          disabled={this.state.disabled.prenom}
          type="text"
          value={this.state.search.prenom}
          title={EurestoI18n.t('crm:Prénom')}
        />
        {!User.TypeAccess.get(Constants.access.EURESTO) && <DataComponent
          title={EurestoI18n.t('crm:Civilité')}
          name="civilite_id"
          disabled={this.state.disabled.civilite_id}
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.searchClient}
          data={this.state.search.civilite_id}
          object={Constants.donnee.civilite}
          module={Constants.module.COMMUN}
        />}
        {/* {
          User.TypeAccess.get(Constants.access.EURESTO) &&
          <DataComponent
            title={EurestoI18n.t('crm:Enseigne')}
            name="enseigne_id"
            disabled={this.state.disabled.enseigne_id}
            type={Constants.typeSaisie.ComboMulti}
            onChange={this.searchClient}
            data={this.state.search.enseigne_id}
            object={Constants.donnee.enseigne}
            module={Constants.module.CRM}
          />
        } */}
        <DataComponent
          title={EurestoI18n.t('crm:Type')}
          name="type_client_id"
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.searchClient}
          disabled={this.state.disabled.type_client_id}
          data={this.state.search.type_client_id}
          object={Constants.donnee.type_client}
          module={Constants.module.CRM}
        />
        {
          User.TypeAccess.get(Constants.access.EURESTO) &&
          <Input
            onChange={this.searchClient}
            name="code"
            disabled={this.state.disabled.code}
            type="text"
            className="upText"
            value={this.state.search.code}
            title={EurestoI18n.t('crm:Code')}
          />
        }
        <Input
          onChange={this.searchClient}
          name="grc_contact.email"
          disabled={this.state.disabled.email}
          type="text"
          value={this.state.search["grc_contact.email"]}
          title={EurestoI18n.t('crm:E-mail')}
        />
        <Input
          onChange={this.searchClient}
          name="telephone"
          disabled={this.state.disabled.telephone}
          type="phone"
          value={this.state.search.telephone}
          title={EurestoI18n.t('crm:Téléphone')}
        />
        <Input
          onChange={this.searchClient}
          disabled={this.state.disabled.cp}
          name="!cp"
          type="text"
          value={this.state.search['!cp']}
          title={EurestoI18n.t('crm:!Code Postal')}
        />
        <Input
          onChange={this.searchClient}
          disabled={this.state.disabled.ville}
          name="ville"
          type="text"
          value={this.state.search.ville}
          title={EurestoI18n.t('crm:Ville')}
        />
        <DataComponent
          onChange={this.searchClient}
          disabled={this.state.disabled.pays_id}
          name="pays_id"
          data={this.state.search.pays_id}
          object={'pays'}
          type={Constants.typeSaisie.PaysNationaliteLangue}
          defineData={true} />
        {
          User.TypeAccess.get(Constants.access.EURESTO) &&
          <DataComponent
            title={EurestoI18n.t('crm:Option')}
            disabled={this.state.disabled.option_id}
            name="option_id"
            type={Constants.typeSaisie.ComboMulti}
            onChange={this.searchClient}
            data={this.state.search.option_id}
            object={Constants.donnee.option}
            module={Constants.module.COMMUN}
          />
        }
        {User.TypeAccess.get(Constants.access.EURESTO) &&
          <Multiple title={EurestoI18n.t('crm:Type Contact')} name="type_contact_id"
            onChange={this.searchClient}
            disabled={this.state.disabled.type_contact_id}
            value={this.state.search.type_contact_id} options={[{
              value: 3,
              label: 'Groupe'
            }, {
              value: 4,
              label: 'Etablissement'
            }, {
              value: 8,
              label: 'Autre'
            }]} />}
        <Multiple title={EurestoI18n.t('crm:Personne/entité')} name="entite"
          onChange={this.searchClient}
          disabled={this.state.disabled.entite}
          value={this.state.search.entite} options={[{
            value: 1,
            label: 'Personne'
          }, {
            value: 2,
            label: 'Entité'
          }]} />
        {
          !User.TypeAccess.get(Constants.access.EURESTO) &&
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
            <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
              <Multiple title={EurestoI18n.t('crm:Public')} name="public"
                onChange={this.searchClient}
                disabled={this.state.disabled.public}
                value={this.state.search.public} options={[{
                  value: 1,
                  label: 'Oui'
                }, {
                  value: 0,
                  label: 'Non'
                }]} />
            </Grid>
            <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
              <Multiple title={EurestoI18n.t('crm:Confidentiel')} name="confidentiel"
                onChange={this.searchClient}
                disabled={this.state.disabled.confidentiel}
                value={this.state.search.confidentiel} options={[{
                  value: 1,
                  label: 'Oui'
                }, {
                  value: 0,
                  label: 'Non'
                }]} />
            </Grid>
          </Grid>
        }
        {
          User.TypeAccess.get(Constants.access.EURESTO) &&
          <React.Fragment>
            <Input
              onChange={this.searchClient}
              name="!version"
              disabled={this.state.disabled["!version"]}
              type="text"
              value={this.state.search["!version"]}
              title={EurestoI18n.t('crm:Version')}
            />
            <Multiple title={EurestoI18n.t('crm:Licence')}
              name="licence_active"
              disabled={this.state.disabled.licence_active}
              onChange={this.searchClient}
              value={this.state.search.licence_active}
              options={[{
                value: 1,
                label: 'Active'
              }, {
                value: 0,
                label: 'Archivée'
              }, {
                value: -1,
                label: 'Bloquée'
              }]} />
          </React.Fragment>
        }
        <Select title={EurestoI18n.t('crm:Archivé')} name="?actif"
          autoComplete={false}
          disabled={this.state.disabled.actif}
          style={{ paddingBottom: 0 }}
          onChange={this.searchClient}
          value={this.state.search['?actif']}
          options={[{
            value: -1,
            label: 'Oui'
          }, {
            value: 1,
            label: 'Non'
          }]} />

        <Input
          onChange={this.searchClient}
          disabled={this.state.disabled.acronis}
          name="acronis"
          type="text"
          value={this.state.search.acronis}
          title={EurestoI18n.t('crm:Acronis')}
        />
        {/*<Button variant={'contained'} style={{ marginTop: 5 }} className={'EurestoError EurestoText--text'}
                onClick={this.clearSearchClient}>RAZ</Button>*/}
      </Grid>
    )
  }

}

export default DatagridContact



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Search/index.js